// Cart Auto-Refresh
(() => {
  let timeoutId;
  
  document.addEventListener('cart-drawer:updated', () => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      CartDrawerSection.refresh();
    }, 1000);
  });
})();